module.exports = __webpack_public_path__ + "static/img/高温2.fd60db3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/smeltingEquipment/高温2.jpg
// module id = 5hD0
// module chunks = 1